import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { FileUploadMultipleComponent } from '../file-upload/file-upload-multiple/file-upload-multiple.component';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { RichTextDocumentComponent } from '../richTextDocument/rich-text-document/rich-text-document.component';
import { NgxEditorModule, toHTML } from 'ngx-editor';
import { MessageAttachmentTemplateDialogComponent } from './message-attachment-template-dialog/message-attachment-template-dialog.component';
import { snackbarService } from '@one/web-components';
import { NotificationDetailsService } from '../../notification/notification-details/notification-details.service'

@Component({
  selector: 'dl-message-attachment',
  standalone: true,
  imports: [OneWebComponentsAngularModule, NgxEditorModule, RichTextDocumentComponent, FileUploadMultipleComponent, ReactiveFormsModule, FormsModule, MessageAttachmentTemplateDialogComponent],
  templateUrl: './message-attachment.component.html',
  styleUrl: './message-attachment.component.scss'
})
export class MessageAttachmentComponent implements OnInit {

  public visible = false;
  public isPopupOpen = false;
  subValue: string;
  public constructor(private changeDetectorRef: ChangeDetectorRef, private _QnSbnDataService: QnSbnDataServiceService, private qnsbnservice: QnSbnService, private notificationDetailsService: NotificationDetailsService) { }
  public subjectname = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]);

  public updateFeedbackOptions: Subject<any> = new Subject<any>();
  public addTempleteCheck = false;
  public disabledApplyCheckbox = true;
  public disbledApplyButton = true;
  public isAfoBtnDisabled = false;
  public isAfoBtnExpanded = false;
  public applybuttonClickSnackmessage = '';
  public templateColumn = ['dragHandle', 'selectText', 'messageTemplate', 'iconSets'];
  public templateData = [];

  public inputData: { tableData: any[], columnData: string[] } = {
    tableData: [],
    columnData: []
  };

  @Input() public textDoc;
  public keyUpForRTE = false;
  public keyUpForSubjectName = false;
  public notificationData: any;
  public templateSubject: string = '';
  public templateEmailText: string = '';
  public templateId: string = '';

  public ngOnInit(): void {
    this.subjectname.valueChanges.subscribe(x => {
      this.applybuttonClickSnackmessage = 'AddMessageFromTemplate';
      this.getApplybuttonStatus();
    });
    this._QnSbnDataService.mappingData$.subscribe(observer => {
      this.notificationData = observer['localNotificationId'];
      if (!this._QnSbnDataService.isEmpty(observer['messageAttachment'])) {
        this.templateSubject = observer['messageAttachment']['subjectName'];
        this.templateEmailText = observer['messageAttachment']['messageAttachmentRTEText'];
        this.templateId = observer['messageAttachment']['templateId'];
        this.subjectname.setValue(this.templateSubject);
        this.textDoc = this.templateEmailText;
        

      }
    })
    this.notificationDetailsService.setFilesToBeAddedLength(10)
  }



  public onKeyupSubjectName(evt) {
    evt.preventDefault();
    this.keyUpForSubjectName = true;
  }

  public onBlurSubjectName(evt) {
    this.subjectname.setValue(this.subjectname.value.trim());
    this.addProduct(this.subjectname.value, this.textDoc);
  }

  public createTemplateUsingApply(): void {
    const newTemplateData = {
      "templateSubject": this.subjectname.value,
      "templateBody": this.textDoc,
      "notificationType": this.notificationData.Type,
      "messageType": "Email",
      "templateLanguage": this.notificationData.LocalNotificationLanguage
    };
    this.qnsbnservice.createUpdateMessageTemplate(newTemplateData).subscribe({
      next: (responseData: any) => {
        this.addProduct(responseData.templateSubject, responseData.templateBody);
        this.snackBarMessage('positive', 'Message successfully added to templates');
        this.addTempleteCheck = false;
        this.disabledApplyCheckbox = true;
        this.disbledApplyButton = true;
        this.changeDetectorRef.detectChanges();
      },
      error: (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Could not save Message template.');
      },

    });
  }

  public onApplybuttonAction(): void {
    // Disable button immediately to prevent multiple clicks
    this.disbledApplyButton = true;
    
    this.qnsbnservice.getMessageTemplate(this.notificationData.Type, this.notificationData.LocalNotificationLanguage).subscribe(
      (data: any) => {
        if (data.errorMessage) {
          this.createTemplateUsingApply();
        } else {
          const templateExist = data.MessageTemplates.some(template =>
            template.templateDetails.templateBody === this.textDoc &&
            template.templateDetails.templateSubject === this.subjectname.value);
          if (templateExist) {
            this.snackBarMessage('positive', 'Template already exist with same data. Please verify the template.');
            this.addTempleteCheck = false;
            this.disabledApplyCheckbox = true;
            this.disbledApplyButton = true;
            return;
          } else {
            this.createTemplateUsingApply();
          }
        }
      },
      (error: HttpErrorResponse) => {
        this.createTemplateUsingApply();
      }
    );
  }

  public chkApplyChange(values: any): void {
    if (this.addTempleteCheck && this.subjectname.status === 'VALID' && this.textDoc && this.textDoc !== '<p></p>') {
      this.disbledApplyButton = false;
     
    } else {
      this.disbledApplyButton = true;
     
    }
    this.changeDetectorRef.detectChanges();
  }

  public addProduct(subjectname, docRTEtext) {
    this._QnSbnDataService.getMappedQnsbnData({
      "subjectName": subjectname,
      "messageAttachmentRTEText": docRTEtext,
      "templateId": this.templateId || ""
    }, "MessageAttachment");
  }

  public openMsgAttachTempleteDialog(): void {
    this.qnsbnservice.getMessageTemplate(
      this.notificationData?.Type,
      this.notificationData?.LocalNotificationLanguage
    ).subscribe({
      next: (data: any) => {
        if (data.errorMessage) {
          this.snackBarMessage('alarm', data.errorMessage.errorMessage);
        } else {
          this.displayMessageTemplateDialog(data.MessageTemplates);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Could not fetch message templates.');
      }
    });
  }

  public displayMessageTemplateDialog(tempData: any): void {
    this.isAfoBtnDisabled = false;
    this.isAfoBtnExpanded = false;
    const tableColumnData = ['dragHandle', 'selectText', 'messageTemplate', 'iconSets'];
    this.inputData = {
      tableData: tempData,
      columnData: tableColumnData
    };
    this.visible = true;
    this.changeDetectorRef.detectChanges();
  }

 public onDialogClose(result: any): void {
  // Close the dialog if cancel was clicked (no data)
  if (!result || !result.data) {
    this.visible = false;
    this.changeDetectorRef.detectChanges();
    return;
  }
  this.isAfoBtnDisabled = false;
  this.isAfoBtnExpanded = false;
  this.templateColumn = result?.data?.newColumnData;
  this.templateData = result?.data?.newTableData;
  const templateItem = this.templateData[0];
  const templateDetails = templateItem?.templateDetails || templateItem;
  this.templateId = templateItem?.templateId || '';
  this.templateSubject = templateDetails?.templateSubject || '';
  this.templateEmailText = templateDetails?.templateBody || '';
  
  // Update the form fields and save to service
  this.subjectname.setValue(this.templateSubject);
  this.textDoc = this.templateEmailText;
  this.addProduct(this.templateSubject, this.templateEmailText);
  
  this.visible = false;
  this.applybuttonClickSnackmessage = 'AddMessageFromTemplate';
  this.changeDetectorRef.detectChanges();
}

  public setRTEText(evt): void {
    

    const newText = toHTML(evt);
    if (this.textDoc === newText) {
      return;
    } else {
      this.textDoc = newText;
      this.applybuttonClickSnackmessage = 'AddMessageFromTemplate';
      this.getApplybuttonStatus();
      this.addProduct(this.subjectname.value, this.textDoc);
    }
  }

  public getApplybuttonStatus(): void {
    if (this.subjectname.status === 'VALID' && this.textDoc && this.textDoc !== '<p></p>') {
      this.disabledApplyCheckbox = false;
      // Enable Apply button only if checkbox is checked
      if (this.addTempleteCheck) {
        this.disbledApplyButton = false;
      } else {
        this.disbledApplyButton = true;
      }
    } else {
      this.disbledApplyButton = true;
      this.disabledApplyCheckbox = true;
    }
  }

  ngOnDestroy(): void {
    this.addProduct(this.subjectname.value, this.textDoc);
  }

  snackBarMessage(status: any, message: string) {
    snackbarService.show({
      message: message,
      snackbarProps: {
        status: status,
        direction: 'horizontal',
        showClose: true,
        elevated: false,
        duration: 5000,
        verticalPlacement: 'top',
        horizontalPlacement: 'right',
      }
    });
  }
}

